import React, { useState, useEffect, useRef } from "react";
import "./style.css";
import { Button, Menu, MenuButton, MenuList, MenuItem, Input } from "@chakra-ui/react";
import { ClockIcon } from "../../../Assets/images/svgs";

const TimePicker = ({ onSelect, value, rideStart, rideEnd }) => {
  const [ showTimePickerMenu, setShowTimePickerMenu ] = useState(false);

  const [ selectedSlot, setSelectedSlot ] = useState({ });
  const [ selectedTimePeriod, setSelectedTimePeriod ] = useState("");

  const generateTimePickerSlots = () => {
    const timeSlots = [];

    let currentSlot = new Date();
    currentSlot.setHours(12);
    currentSlot.setMinutes(0);

    for (let i = 0; i < 24; i++) {
      timeSlots.push({
        hrs: currentSlot.getHours(),
        mins: currentSlot.getMinutes(),
      });

      currentSlot.setMinutes(currentSlot.getMinutes() + 30);
    }

    return timeSlots;
  }

  const rideData = useRef({ startTs: rideStart, endTs: rideEnd });
  const timePickerSlots = useRef(generateTimePickerSlots());

  useEffect(() => {
    if (!value) {
      setSelectedSlot({ });
      setSelectedTimePeriod("");
    }
  }, [ value ])

  const handleSlotSelection = (slot) => {
    setSelectedSlot(slot);

    if (selectedTimePeriod) {
      setShowTimePickerMenu(false);
      if (onSelect) {
        onSelect(slot, selectedTimePeriod);
      }
    }
  }

  const handleMeridiemSelection = (meridiem) => {
    setSelectedTimePeriod(meridiem);

    if (selectedSlot) {
      setShowTimePickerMenu(false);
      if (onSelect) {
        onSelect(selectedSlot, meridiem);
      }
    }
  }

  return (
    <div className="time-picker">
      <Menu isOpen={showTimePickerMenu} className="time-slot-picker-menu">
        <MenuButton className="slot-picker-menu-button" as={Button} rightIcon={<ClockIcon />} onClick={() => setShowTimePickerMenu(!showTimePickerMenu)}>
          <p className={`${(selectedSlot.hrs || selectedSlot.hrs === 0) ? "selected-time" : ""}`}>{(selectedSlot.hrs || selectedSlot.hrs === 0) ? `${Math.abs(selectedSlot.hrs - 12 || 12)}:${selectedSlot.mins || "00"} ${selectedTimePeriod || ""}` : "Select time"}</p>
        </MenuButton>
        <MenuList className="menu-lists-container">
          {timePickerSlots.current.length ? <MenuList className="time-slots-menu-list">
            <div className="time-slots-list-container">
            {
              timePickerSlots.current.map((slot, idx) => (
                <MenuItem key={idx} onClick={() => handleSlotSelection(slot)} className={`${(selectedSlot.hrs === slot.hrs && selectedSlot.mins === slot.mins) ? "focus-menu-item" : "slots-menu-item"}`}>{`${Math.abs(slot.hrs - 12 || 12)}:${slot.mins || "00"}`}</MenuItem>
              ))
            }
            </div>
          </MenuList> : null}
          <MenuList className="daytime-picker">
            <MenuItem onClick={() => handleMeridiemSelection("AM")} className={`${selectedTimePeriod === "AM" ? "focus-time-period" : ""}`}>AM</MenuItem>
            <MenuItem onClick={() => handleMeridiemSelection("PM")} className={`${selectedTimePeriod === "PM" ? "focus-time-period" : ""}`}>PM</MenuItem>
          </MenuList>
        </MenuList>
      </Menu>
    </div>
  )
}

export default TimePicker